module.exports = __webpack_public_path__ + "img/titleIcon5.220b571c.png";